import Configuration from '@/agilis/util/Configuration'
import { mapGetters } from 'vuex'

export default {
  name: 'TrackerDataTableItemDialogEdit',
  props: {
    mode: String,
    dialogModel: Boolean,
    parentTrackerDTO: {
      type: Object,
      default: () => ({})
    },
    itemDTO: {
      type: Object,
      default: () => ({})
    },
    api: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      formConfiguration: {},
      itemContext: {
        applicationId: this.itemDTO.applicationId,
        workspaceId: this.itemDTO.workspaceId,
        trackerTypeId: this.itemDTO.trackerTypeId,
        trackerId: this.itemDTO.id,
        parentDTO: this.parentTrackerDTO
      },
      dialog: this.dialogModel
    }
  },

  computed: {
    ...mapGetters({
      loading: 'loaderStore/loading',
      trackerTypes: 'contextStore/trackerTypes'
    }),
    trackerType () {
      return Configuration.getTrackerType(this.itemContext.applicationId, this.itemContext.trackerTypeId)
    },
    computeApi () {
      if (this.api) return this.api
      return this.$axios.agilisUrlTracker(this.itemContext.applicationId, this.itemContext.trackerTypeId)
    },
    dataTableConfiguration () {
      if (this.itemContext.trackerTypeId) {
        return Configuration.datatable.getDatatable({ applicationId: this.itemContext.applicationId, trackerTypeId: this.itemContext.trackerTypeId, workspaceId: this.itemContext.workspaceId })
      }
      return {}
    },
    computeTitle () {
      let title = ''
      if (this.mode === 'insert') {
        title = `${this.$t('label.create') + ' ' + this.$t(this.trackerType.name)}`
      } else {
        title = `${this.$t('label.edit') + ' ' + this.$t(this.trackerType.name)}`
      }

      return Configuration.i18n.capitalizePhrase(title)
    }
  },
  watch: {
    dialogModel (newVal) {
      this.dialog = newVal
    },
    dialog (newVal) {
      this.$emit('update:dialogModel', newVal)
    }
  },
  methods: {
    handleCloseDialog () {
      this.dialog = !this.dialog
      this.$emit('TrackerDataTableItemDialogEditClose')
    }
  }
}
